import React, { Component } from "react";
import Client from "../Client";
import BlackLoading from "../images/black-loader.gif";
import marked from "marked"; //to make font bold and headings
import LocallyGrownHolidayPlantsGallery from "./LocallyGrownHolidayPlantsGallery";

class LocallyGrownHolidayPlants extends Component {
  constructor(props) {
    super(props);
    this.state = {
      locallyGrownHolidayPlantspage: [],
    };
  }

  componentDidMount() {
    Client.getEntries({
      content_type: "locallyGrownHolidayPlants",
    }).then((entries) => {
      this.setState({ locallyGrownHolidayPlantspage: entries.items });
    });
  }

  //to make font bold and headings
  getParsedMarkdown(locallyGrownHolidayPlantsDescription) {
    return {
      __html: marked(locallyGrownHolidayPlantsDescription, { sanitize: false }),
    };
  }
  //to make font bold and headings - end

  render() {
    return (
      <>
      <div className="container-fluid">
        {this.state.locallyGrownHolidayPlantspage.length === 0 ? (
          <div align="center">
            <img src={BlackLoading} alt="Loading..." />
          </div>
        ) : (
          <div className="row">
            {this.state.locallyGrownHolidayPlantspage.map((item, index) => {
              return (
                <div key={index} className="col-lg-12">
                  <div className="text-left pt-2">
                    <h1 className="text-uppercase">{item.fields.locallyGrownHolidayPlantsTitle}</h1>
                    {/* <h2 className="lead">{item.fields.locallyGrownHolidayPlantsShortDetails}</h2> */}
                  </div>

                  <div className="pt-2">
                    <div className="row">
                      {/* <div className="col-lg-4">
                        <img
                          className="img-fluid"
                          src={item.fields.locallyGrownHolidayPlantsImg.fields.file.url}
                          alt="icon"
                        />
                        
                      </div> */}
                      <div className="col-lg-8">
                        {/* <p>{item.fields.aboutDescription}</p> */}
                        <div dangerouslySetInnerHTML = {this.getParsedMarkdown(
                            item.fields.locallyGrownHolidayPlantsDescription
                        )}></div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div className="pt-4">
        <LocallyGrownHolidayPlantsGallery/>
      </div>
      </>
    );
  }
}

export default LocallyGrownHolidayPlants;
